import React from 'react'

const BoxElement = ( props ) => {
  const { styles } = props.item.content
  return (
    <div style={styles}>
    </div>
  )
}

export {
  BoxElement
}


// WEBPACK FOOTER //
// ./src/components/commons/editor/BoxElement.js